import TngTransactionReportTable from "./tngTransactionReportTable.container";

export default TngTransactionReportTable;
